import { getStore } from '../store/store';

export const areWin32IconsRegistered = (isMultiLineRibbon: boolean): boolean =>
    isMultiLineRibbon
        ? getStore().areSmallIconsRegistered && getStore().areLargeIconsRegistered
        : getStore().areDefaultIconsRegistered;
